module.exports = {
	ebooks: 'https://acadmin.net/ebooks',
	contact_hero: 'https://cdn.activechristianity.org/bymnzyzb3dqxb1bjunj9.jpg',
	podcast_logo: 'https://cdn.activechristianity.org/en/13359e9185313f4724f67a18b332189b.jpg',
	contact_form_api: 'https://cors-proxy.gerard-lamusse.workers.dev/?url=https://app.windmill.dev/api/w/bcc-active-christianity/jobs/run_wait_result/f/f/forms/submit-contact',
	dummy_image_api: 'https://dummyimage.com',
	random_image_api: 'https://source.unsplash.com/collection/1308823',
	about_us_video: 'https://www.youtube-nocookie.com/embed/sAbW36EzKIc',
	reftagger: 'https://api.reftagger.com/v2/RefTagger.js',
	api_host: 'https://acadmin.net',
	api_url: 'https://acadmin.net/graphql',
	translation_google_sheet_auth: 'AIzaSyASDGn4oZErww-RsW6kBPnQz7tCB6x3Fpk',
	translation_google_sheet_id: '1waay0ca8OdtmJFyMtKzOsje_gocnWwfI2ZUFh5Bg90U',
	test: 'test',
	slug_translation: 'https://acadmin.net/day4/string_translations',
	gtm_id: 'GTM-TPNPVVV'
};
